import axios from '@axios'

const PREFIX = '/alvaras'

export default {

  getAlvaras(page, pageSize, filtros) {
    return axios.post(`${PREFIX}?page=${page}&pageSize=${pageSize}`, filtros)
  },
  getAllEmpresas() {
    return axios.get(`${PREFIX}/empresas`)
  },
  GetAlvaraById(id) {
    return axios.get(`${PREFIX}/${id}`)
  },
  createAlvara(alvara) {
    return axios.post(`${PREFIX}/add`, alvara)
  },
  delete(id) {
    return axios.delete(`${PREFIX}/${id}`)
  },
  update(id, alvara) {
    return axios.put(`${PREFIX}/${id}`, alvara)
  },
  updateObservacao(id, observacao) {
    return axios.put(`${PREFIX}/${id}/observacao`, observacao)
  },
  getAlvaraByEmpresaId(empresaId, ocultar) {
    return axios.get(`${PREFIX}/empresa/${empresaId}?ocultar=${ocultar}`)
  },
  addHistorico(id, tela) {
    return axios.post(`${PREFIX}/${id}/historico?tela=${tela}`)
  },
  getHistoricos(id) {
    return axios.get(`${PREFIX}/${id}/historico`)
  },
  getAlvarasDispensar(alvaraId) {
    return axios.post(`${PREFIX}/dispensa`, alvaraId)
  },
  exportarRelatorio(filtros) {
    return axios.post(`${PREFIX}/relatorio`, filtros)
  },
}
